import { LoaderFunction } from "@remix-run/router";
import { getWaterfallBreakdownRetrieveLoader } from "gen/endpoints/fund-family-event/fund-family-event";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";
import { composeLoaders } from "shared/utils/RoutingUtils";

type LoaderFactory = ({
  is_equalized_view,
}: {
  is_equalized_view: boolean | undefined;
}) => LoaderFunction;

const composeWaterfallBreakdownLoaders = (
  ...loaderFactories: LoaderFactory[]
) =>
  composeLoaders(
    ...loaderFactories.map((factory) =>
      factory({ is_equalized_view: undefined }),
    ),
    ...loaderFactories.map((factory) => factory({ is_equalized_view: true })),
  );

export const waterfallReviewRoutes: RouteObject = {
  id: "capitalActivityCapitalActivityEventWaterfallReview",
  path: "review/:fundFamilySubEventId",
  children: [
    {
      id: "capitalActivityCapitalActivityEventWaterfallReviewFundPreferredReturn",
      path: "fund-preferred-return/:fundEntityId",
      lazy: async () => {
        const { WaterfallReviewPreferredReturnFundPage } = await import(
          "features/waterfall/review/WaterfallReviewPreferredReturnPage"
        );
        return { Component: WaterfallReviewPreferredReturnFundPage };
      },
      handle: {
        title: i18n.t("waterfall:review.fundLevel.breadcrumb"),
      },
    },
    {
      id: "capitalActivityCapitalActivityEventWaterfallReviewRoutes",
      path: "",
      lazy: async () => {
        const { WaterfallReviewPage } = await import(
          "features/waterfall/review/WaterfallReviewPage"
        );
        return { Component: WaterfallReviewPage };
      },
      loader: composeWaterfallBreakdownLoaders(
        getWaterfallBreakdownRetrieveLoader,
      ),
    },
    {
      id: "capitalActivityCapitalActivityEventWaterfallReviewFund",
      path: "fund-level/:fundEntityId",
      lazy: async () => {
        const { WaterfallReviewPageFund } = await import(
          "features/waterfall/review/WaterfallReviewPage"
        );
        return {
          Component: WaterfallReviewPageFund,
        };
      },
      handle: {
        title: i18n.t("waterfall:review.fundLevel.breadcrumb"),
      },
    },
    {
      id: "capitalActivityCapitalActivityEventWaterfallReviewBreakdown",
      path: "breakdown/:fundEntityId/investor-entity/:investorEntityId",
      children: [
        {
          id: "capitalActivityCapitalActivityEventWaterfallReviewBreakdownInvestor",
          index: true,
          lazy: async () => {
            const { WaterfallReviewPageInvestorEntity } = await import(
              "features/waterfall/review/WaterfallReviewPage"
            );
            return { Component: WaterfallReviewPageInvestorEntity };
          },
        },
        {
          id: "capitalActivityCapitalActivityEventWaterfallReviewBreakdownInvestorPreferredReturn",
          path: "investor-preferred-return",
          lazy: async () => {
            const { WaterfallReviewPreferredReturnInvestorPage } = await import(
              "features/waterfall/review/WaterfallReviewPreferredReturnPage"
            );
            return { Component: WaterfallReviewPreferredReturnInvestorPage };
          },
          handle: {
            title: i18n.t("waterfall:review.investorTableLevel.breadcrumb"),
          },
        },
      ],
    },
  ],
};
